<template>

    <!-- Start Chose Us Area
    ============================================= -->
    <div class="choseus-area default-padding-top">
      <div class="container">
        <div class="choseus-items">
          <div class="row align-center">
            <div class="col-lg-6">
              <div class="thumb wow fadeInLeft" data-wow-delay="0.5s">
                <img src="assets/img/illustration/8.png" alt="Thumb" />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="info wow fadeInUp">
                <h2>Transforma tu empresa</h2>
                <p>Adhiérete a la transformación digital.</p>
                <ul>
                  <li>
                    <span><i class="ti-check"></i> Crea un usuario</span>
                  </li>
                  <li>
                    <span
                      ><i class="ti-check"></i> Selecciona tus programas
                      favoritos</span
                    >
                  </li>
                  <li>
                    <span
                      ><i class="ti-check"></i> Ejecuta tus aplicaciones en tu
                      equipo o navegador favorito</span
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Chose Us -->

</template>


<script>
    export default {
        name: "Banner2",
        components: {},
        beforeMount() {},
    };
</script>